
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Search": () => {
return Promise.all(/*  | __federation_expose_Search */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("859"), __webpack_require__.e("997")]).then(() => (() => (__webpack_require__(8280))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };